import { render, staticRenderFns } from "./AppScrollbar.vue?vue&type=template&id=7cb0d204&scoped=true&"
import script from "./AppScrollbar.vue?vue&type=script&lang=js&"
export * from "./AppScrollbar.vue?vue&type=script&lang=js&"
import style0 from "./AppScrollbar.vue?vue&type=style&index=0&id=7cb0d204&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb0d204",
  null
  
)

export default component.exports